<template>
  <Card>
    <h1 slot="Title">Work Breakdown Structure (WBS) Element</h1>
    <div slot="MainContent">
      <p>
        Work Breakdown Structure (WBS) Element (<b>S.00000012</b>): is a model of the project that organizes project tasks into a hierarchy. 
      </p>
      <p>
        202011D20_  A76VV 131096QLOG 6100.2617 <b><u>S.00000012</u></b> 1000000067  021001 
      </p>
    </div>
    <p><strong>Work Breakdown Structure (WBS) Element </strong></p>
    <p>The work breakdown structure (WBS) Element is a model of the project that organizes project tasks into a hierarchy.</p>
    <p>It is the functional basis for further planning steps in a project, for example, for process planning, cost planning, scheduling, capacity planning or costing, as well as project control.</p>
    <p>It gives you a clear picture of the project and facilitates the coordination and implementation of the project from a management standpoint.</p>
    <p>It shows the work involved in a project.</p>
  </Card>
</template>
<style scoped>


</style>
<script>
import Card from '../../../components/Card.vue';

export default {

  components: {
    Card
  },
  name: 'WorkBreakdownStructureWBSElement',
  
  data() {
    return {
      Image: require('@/assets/The Basic 6-Digit USSGL Accounts Classification_150ppi.png')
    }
  }
  
}
</script>